import { TSelectboxOption } from "../../../components/admin/formFields"

export const ROLE_ACCESS_LEVELS = {
  NONE: 0,
  READ: 1,
  WRITE: 2,
  ALL: 3
}
export const ROLE_ACCESS_LEVEL_LABELS = {
  [ROLE_ACCESS_LEVELS.NONE]: "None",
  [ROLE_ACCESS_LEVELS.READ]: "Read/View",
  [ROLE_ACCESS_LEVELS.WRITE]: "Write/Edit",
  [ROLE_ACCESS_LEVELS.ALL]: "New/Delete"
}

// use dropdown options based on max access level
export const ROLE_ACCESS_LEVELS_OPTIONS = {
  NONE: [
    { value: `${ROLE_ACCESS_LEVELS.NONE}`, label: ROLE_ACCESS_LEVEL_LABELS[ROLE_ACCESS_LEVELS.NONE] }
  ] as TSelectboxOption[],
  READ: [
    { value: `${ROLE_ACCESS_LEVELS.NONE}`, label: ROLE_ACCESS_LEVEL_LABELS[ROLE_ACCESS_LEVELS.NONE] },
    { value: `${ROLE_ACCESS_LEVELS.READ}`, label: ROLE_ACCESS_LEVEL_LABELS[ROLE_ACCESS_LEVELS.READ] }
  ] as TSelectboxOption[],
  WRITE: [
    { value: `${ROLE_ACCESS_LEVELS.NONE}`, label: ROLE_ACCESS_LEVEL_LABELS[ROLE_ACCESS_LEVELS.NONE] },
    { value: `${ROLE_ACCESS_LEVELS.READ}`, label: ROLE_ACCESS_LEVEL_LABELS[ROLE_ACCESS_LEVELS.READ] },
    { value: `${ROLE_ACCESS_LEVELS.WRITE}`, label: ROLE_ACCESS_LEVEL_LABELS[ROLE_ACCESS_LEVELS.WRITE] }
  ] as TSelectboxOption[],
  ALL: [
    { value: `${ROLE_ACCESS_LEVELS.NONE}`, label: ROLE_ACCESS_LEVEL_LABELS[ROLE_ACCESS_LEVELS.NONE] },
    { value: `${ROLE_ACCESS_LEVELS.READ}`, label: ROLE_ACCESS_LEVEL_LABELS[ROLE_ACCESS_LEVELS.READ] },
    { value: `${ROLE_ACCESS_LEVELS.WRITE}`, label: ROLE_ACCESS_LEVEL_LABELS[ROLE_ACCESS_LEVELS.WRITE] },
    { value: `${ROLE_ACCESS_LEVELS.ALL}`, label: ROLE_ACCESS_LEVEL_LABELS[ROLE_ACCESS_LEVELS.ALL] }
  ] as TSelectboxOption[]
}